import Game from "../Model/Game"
import FighterGenerator from "./FighterGenerator"
import FighterInterface from "../Model/FighterInterface"
import config from "../config.json"

export default class FightResolver {
  constructor(private readonly fighterGenerator: FighterGenerator) {}

  public resolve(enemy: FighterInterface, game: Game): Game {
    const normalized: number = enemy.value.normalize()
    if (normalized > game.me.value.normalize()) {
      return game
        .endFight(false)
        .defeat(
          `Enemy: ${enemy.value} === ${enemy.value.normalize()}\nMe: ${game.me.value} === ${game.me.value.normalize()}`,
        )
    }

    const myNewValue: FighterInterface = this.calculateMyNextValue(enemy, game)
    const nextNumber: number | undefined = game.enemiesQueue[0]

    let g: Game = new Game(
      game.id,
      myNewValue,
      // Remove enemy so we can find the spot for the next one.
      game.enemies.filter((e: FighterInterface): boolean => e.id !== enemy.id),
      game.enemiesQueue.slice(1),
      game.time,
      game.level + 1,
      game.initialValue,
      "fighting",
    )

    const nextEnemy: FighterInterface | undefined =
      nextNumber !== undefined ?
        this.fighterGenerator.generate(nextNumber, "enemy", g)
      : undefined

    if (nextEnemy !== undefined) {
      return new Game(
        g.id,
        myNewValue,
        [...g.enemies, nextEnemy],
        g.enemiesQueue,
        g.time,
        g.level,
        g.initialValue,
        g.status,
      )
    }

    if (g.enemies.length === 0) {
      return g.setStatus("victory").endFight(true)
    }

    return g.endFight(true)
  }

  private calculateMyNextValue(
    enemy: FighterInterface,
    game: Game,
  ): FighterInterface {
    return this.fighterGenerator.generate(
      Math.ceil(
        (game.me.value.normalize() + enemy.value.normalize()) *
          config.sumGrowthCoefficient,
      ),
      "me",
    )
  }
}
